import type { listingOwnershipPeriodBusinessModel_enum } from '@vrplatform/graphql';

const titles: Record<listingOwnershipPeriodBusinessModel_enum, string> = {
  co_host: 'Co-Host',
  co_host_airbnb: 'Co-Host (Airbnb only)',
  managed: 'Managed',
};

export const formatOwnershipBusinessModel = (
  type: listingOwnershipPeriodBusinessModel_enum
) => {
  return titles[type];
};
